

























#Documentation: https://longbill.github.io/jquery-date-range-picker/
require('../../vendor/jquery-date-range-picker/jquery.daterangepicker.min.js')
helpers = require('../../helpers.coffee')

view_model = {

  mixins: [require('../../mixins/users_options.coffee')]

  data: ->
    users_options: [{ value: null, text: 'Carregando...'}]
    user_filter: {}
    loading: false
    start_date: moment().startOf('day').format('YYYY-MM-DD')
    end_date: moment().endOf('day').format('YYYY-MM-DD')
    current_user: Session.current_user
    done_tasks_grouped: {}

  methods:
    valid_label_task_card: (key) ->
      @label_of_tasks[key] && @label_of_tasks[key].length > 0 

    countingNumber: (number) ->
      result = number
      result = '0'+number if number < 10 && number > 0
      result

    initializeDatePicker:->
      jQuery('#calendar-input').dateRangePicker({
        language: 'pt',
        hoveringTooltip: false,
        inline: true,
        container: '#calendar',
        alwaysOpen: true,
        format: 'dddd DD/MM',
        singleMonth: true,
        separator: ' - ',
        showTopbar: false
      }).bind('datepicker-change', (event, obj) => @calendarChanged(obj) )

    calendarChanged: (obj) ->
      @start_date = moment(obj.date1).startOf('day').format('YYYY-MM-DD')
      @end_date = moment(obj.date2).endOf('day').format('YYYY-MM-DD')
      @loadGroupedDoneTasksData(@card_filters)

    loadGroupedDoneTasksData: (filters) ->
      @loading = true
      @reports_resource.groupedDoneTasks(@loadGroupedDoneTasksDataSuccess, @unkonwnError, params: {q: filters})

    loadGroupedDoneTasksDataSuccess: (data) ->
      @done_tasks_grouped = @mergingDoneTasks(data.body)
      @loading = false

    mergingDoneTasks: (done_tasks) ->
      result = {
        'ManualTasksServices::Email': 0,
        'ManualTasksServices::Linkedin': 0,
        'ManualTasksServices::Phonecall': 0,
        'ManualTasksServices::Social': 0
      }
      for task in done_tasks
        result[task.service] += task.count
      result

    declaringVariables: ->
      @label_of_tasks = {
        'ManualTasksServices::Email': 'Emails manuais',
        'ManualTasksServices::Linkedin': 'Linkedin',
        'ManualTasksServices::Phonecall': 'Ligações',
        'ManualTasksServices::Social': 'Sociais'
      }
      img_prefix = '../../assets/images/icons/'
      @class_of_tasks = {
        'ManualTasksServices::Email': 'email',
        'ManualTasksServices::Linkedin': 'linkedin',
        'ManualTasksServices::Phonecall': 'call',
        'ManualTasksServices::Social': 'social'
      }

  computed:
    date_string: ->
      moment(@start_date).format('dddd DD/MM')+ ' - ' +moment(@end_date).format('dddd DD/MM')

    card_filters: ->
      filters = { period: { from: @start_date, to: @end_date } }
      if @current_user.isManager() || @current_user.isMonitoringManager()
        filters.user_id_eq = @user_filter.user_id_eq if @user_filter
      else
        filters.user_id_eq = @current_user.id
      filters

  created: ->
    @reports_resource = new ReportsResource(Session.current_company.id)
    @loadGroupedDoneTasksData(@card_filters)
    @declaringVariables()


  mounted: ->
    @initializeDatePicker()
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/calendar.vue